import { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import { usePluginspace } from "./usePluginspace";
import {
  CashbackFeatureFlags,
  clearCashbackFeatureCache,
  resolveCashbackFeatureEnabled,
} from "../pages/NewCheckoutCart/factory/cashbackHelper";

const DEFAULT_FLAGS: CashbackFeatureFlags = {
  enabled: false,
  totvsAble: false,
  cashbackAble: false,
  cashbackTemplateId: null,
};

/**
 * Gate de feature do cashback.
 * - TOTVS (105) able: bloqueia
 * - GET /api/plugintemplate/cashback com content.able: habilita
 */
export function useCashbackFeature() {
  const { getToken } = usePluginspace();
  const [flags, setFlags] = useState<CashbackFeatureFlags>(DEFAULT_FLAGS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(
    async (force = false) => {
      try {
        if (force) clearCashbackFeatureCache();
        const token = await getToken();
        const resolved = await resolveCashbackFeatureEnabled(api, token);
        setFlags(resolved);
      } catch (error) {
        console.error(error);
        setFlags(DEFAULT_FLAGS);
      } finally {
        setLoaded(true);
      }
    },
    [getToken]
  );

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    cashbackFeatureEnabled: flags.enabled,
    cashbackFeatureLoaded: loaded,
    cashbackFeatureFlags: flags,
    refreshCashbackFeature: refresh,
  };
}
